import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const consumerClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

// Add auth token if available
consumerClient.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('consumer_session_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
      config.params = { ...config.params, user_authenticated: true };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const consumerAPI = {
  // Get deals with filters
  getDeals: async (params = {}) => {
    const response = await consumerClient.get('/api/consumer/deals', { params });
    return response.data;
  },

  // Get single deal detail
  getDealDetail: async (dealId) => {
    const response = await consumerClient.get(`/api/consumer/deals/${dealId}`);
    return response.data;
  },

  // Get categories
  getCategories: async () => {
    const response = await consumerClient.get('/api/consumer/categories');
    return response.data;
  },

  // Get merchants
  getMerchants: async () => {
    const response = await consumerClient.get('/api/consumer/merchants');
    return response.data;
  },

  // Track deal click
  trackClick: async (dealId) => {
    const response = await consumerClient.post(`/api/consumer/deals/${dealId}/click`);
    return response.data;
  },

  // Watchlist operations
  addToWatchlist: async (dealId) => {
    const response = await consumerClient.post(`/api/consumer/watchlist/add`, { deal_id: dealId });
    return response.data;
  },

  removeFromWatchlist: async (dealId) => {
    const response = await consumerClient.delete(`/api/consumer/watchlist/remove/${dealId}`);
    return response.data;
  },

  getWatchlist: async () => {
    const response = await consumerClient.get('/api/consumer/watchlist/');
    return response.data;
  },

  // Alert preferences
  updatePreferences: async (preferences) => {
    const response = await consumerClient.put('/api/consumer/watchlist/preferences', preferences);
    return response.data;
  },

  // Get alerts
  getAlerts: async () => {
    const response = await consumerClient.get('/api/consumer/watchlist/alerts');
    return response.data;
  },
};

export default consumerClient;
